const mediumSize = 1023;
const isMobile = () => {
  if (window.innerWidth >= mediumSize) {
    return false;
  } else {
    return true;
  }
};
export default isMobile;
